export const weekDays = [
    { id: 0, shortLabel: 'S', label: 'Sunday' },
    { id: 1, shortLabel: 'M', label: 'Monday' },
    { id: 2, shortLabel: 'T', label: 'Tuesday' },
    { id: 3, shortLabel: 'W', label: 'Wednesday' },
    { id: 4, shortLabel: 'T', label: 'Thursday' },
    { id: 5, shortLabel: 'F', label: 'Friday' },
    { id: 6, shortLabel: 'S', label: 'Saturday' }
];
